import type { DefaultTheme } from "styled-components";

export type CollectionAppearance = "framed" | "embedded";
export type CollectionRowAppearance = "continuous" | "raised";

export type CollectionFrameRecipe = {
  borderWidth: string;
  borderColor: string;
  radius: string;
  surface: string;
};

export type CollectionRowSurface = {
  rest: string;
  hover: string;
  active: string;
  disabled: string;
  selected: string;
  selectedHover: string;
  selectedActive: string;
};

export type CollectionRowRecipe = {
  radius: string;
  divider: string;
  surface: CollectionRowSurface;
};

// 공유 외관은 토큰만 결정한다. 행 간격·높이·그룹 경계는 각 collection의 구조가 소유한다.
export function resolveCollectionFrameRecipe(
  theme: DefaultTheme,
  appearance: CollectionAppearance,
): CollectionFrameRecipe {
  return appearance === "framed"
    ? {
        borderWidth: "1px",
        borderColor: theme.color.border.default,
        radius: theme.shape.radius.surface,
        surface: theme.color.bg.surface,
      }
    : { borderWidth: "0px", borderColor: "transparent", radius: "0px", surface: "transparent" };
}

export function resolveCollectionRowSurface(
  theme: DefaultTheme,
  tone: "transparent" | "raised",
): CollectionRowSurface {
  return {
    ...(tone === "raised"
      ? {
          rest: theme.color.bg.surfaceRaised,
          hover: theme.color.bg.surfaceRaisedHigh,
          active: theme.color.bg.surfaceOverlay,
          // 독립된 행 면에서 한 단계 낮춰 disabled 상태를 구분한다.
          disabled: theme.color.bg.surface,
        }
      : {
          rest: "transparent",
          hover: theme.color.bg.surfaceRaised,
          active: theme.color.bg.surfaceRaisedHigh,
          disabled: theme.color.bg.muted,
        }),
    selected: theme.color.bg.selected,
    selectedHover: theme.color.bg.selectedHover,
    selectedActive: theme.color.bg.selectedActive,
  };
}

export function resolveCollectionRowRecipe(
  theme: DefaultTheme,
  rowAppearance: CollectionRowAppearance,
): CollectionRowRecipe {
  return {
    radius: rowAppearance === "raised" ? theme.shape.radius.surface : "0px",
    divider: theme.color.border.divider,
    surface: resolveCollectionRowSurface(
      theme,
      rowAppearance === "raised" ? "raised" : "transparent",
    ),
  };
}
